
import { defineComponent, PropType } from 'vue'

// @components
import NewModal from '@/common/new-components/NewModal/index.vue'

// @types
import { PredictionCar } from '@/new-services/types/prediction'

export default defineComponent({
    components: {
        NewModal,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        cars: {
            type: Array as PropType<PredictionCar[]>,
            default: () => [],
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        const getClass = (value: number) => (value ? 'text-green-500' : '')

        return {
            onCancel,
            //
            getClass,
        }
    },
})
